import { useQuery } from '@tanstack/react-query';
import api from 'src/api/api';
import { HEADERS } from 'src/constants/headers';
import { ILead } from 'src/interfaces/lead';

const LEAD_QUERY_KEY = 'lead';

export const leadQueryKeys = {
    detail: (leadId: string) => [LEAD_QUERY_KEY, leadId] as const,
};

const getLead = async (leadId: string): Promise<ILead> => {
    const response = await api.get(`/leads/${leadId}`, HEADERS());
    return response.data.data;
};

export const useLeadQuery = (leadId?: string, enabled = true) =>
    useQuery({
        queryKey: leadQueryKeys.detail(leadId || ''),
        queryFn: () => getLead(leadId as string),
        enabled: enabled && Boolean(leadId && leadId !== 'undefined'),
        staleTime: 0,
    });
